import moment from "moment";
import { nanoid } from "nanoid";
import constants from "../constants";
import ModuleHooks from "./ModuleHooks";
import useAxiosPrivate from "./useAxiosPrivate";
import AlertContext from "../context/AlertContext";
import useSubmitAssignment from "./useSubmitAssignment";
import { getDataFromStorage } from "../util";
import useCommonFunctionHooks from "./useCommonFunctionHooks";
import { useCallback, useContext, useRef, useState } from "react";
import UploadAssignment from "../Components/Student/AssignmentPage/UploadAssignment";
import useS3FileManagement from "./useS3FileManagement";
import { useLocation } from "react-router-dom";

export default function AssignmentPageHooks() {
  const Alert = useContext(AlertContext);

  const {
    lpId,
    status,
    isAdmin,
    setScore,
    setLibId,
    navigate,
    testData,
    setStatus,
    setLibType,
    setTestData,
    setIsLoaded,
    setShowMain,
    setLearnerId,
    learnerNotes,
    setShowNotify,
    setFromReport,
    setLpConfigId,
    setIsTakeTest,
    isFromProfile,
    setContentData,
    setApproveData,
    setIsSubmitted,
    setLearnerNotes,
    setIsFullScreen,
    setCurrentIndex,
    setUpdateLeftNav,
    isEditSubmission,
    learnerVideoLink,
    assignmentTestData,
    setIsAddSubmission,
    setSubmissionFiles,
    setLearnerVideoLink,
    setIsEditSubmission,
    setAssignmentTestData,
    assignmentSubmissionFiles,
    contentData,
  } = useContext(AlertContext);

  const axios = useAxiosPrivate();
  const { getPreSignedUrl } = useS3FileManagement();

  const { clearPopupStates } = ModuleHooks();
  const submitAssignment = useSubmitAssignment();

  const { getCatchBlockDetails, getHeaderDetailsForAxios } =
    useCommonFunctionHooks();
  const location = useLocation()
  const isPreview =
    new URLSearchParams(window.location.search).get("mode") === "preview";

  const [referenceLinks, setReferenceLinks] = useState([]);

  const assignmentDueDate = moment(assignmentTestData.dueDate);
  const today = moment(assignmentTestData.serverDate).tz("Asia/Kolkata");
  const diff = assignmentDueDate.diff(today, "minutes");

  const assignmentReferenceLinkRef = useRef([]);

  const [submitWithSandPack, setSubmitWithSandPack] = useState(false);

  const handleRequestFullScreenMode = async (index, link) => {
    const iframeRef = assignmentReferenceLinkRef.current[index];

    iframeRef.requestFullscreen();
    setIsFullScreen(true);
    setCurrentIndex(index);
  };

  const handleExitFullScreen = () => {
    if (document.fullscreenElement === null) {
      setIsFullScreen(false);
    }
  };

  const openSandPackEditor = async () => {
    let count = await window?.electronAPI?.sendScreenInfo();

    if (count?.monitors && count.monitors > 1) {
      setShowNotify({
        show: true,
        title: "Info",
        msg: "You are connected to more than one displays",
      });

      return;
    } else {
      setIsTakeTest(true);
      setIsAddSubmission(true);
      setSubmitWithSandPack(true);
      navigate("/sandpack");
    }
  };

  const handleSetSubmissionFile = () => {
    setSubmissionFiles(
      status === constants.PROGRESS_STATUS.UNLOCKED
        ? []
        : assignmentTestData?.anslinks !== null &&
          assignmentTestData?.anslinks !== undefined &&
          assignmentTestData?.anslinks !== "" &&
          JSON.parse(assignmentTestData?.anslinks).length !== 0
        ? JSON.parse(assignmentTestData.anslinks).map((link) => {
            let linkJson = {
              link: link,
              id: nanoid(),
              fileStatus: "old",
              isUploading: false,
              lastModified: assignmentTestData?.submitteddate,
              submissionDate: assignmentTestData?.submitteddate,
              name:
                link !== null ? link.substring(link.lastIndexOf("/") + 1) : "",
            };

            return linkJson;
          })
        : [],
    );

    if (status === constants.PROGRESS_STATUS.UNLOCKED) setLearnerNotes("");
  };

  const showPopUp = () => {
    setShowNotify({
      show: true,
      size: "lg",
      showClose: true,
      hideButton: true,
      component: "leaderBoard",
      msg: <UploadAssignment />,
      title: "Upload assignment",
    });
  };

  const handleAddAssignment = () => {
    setIsAddSubmission(true);
    setSubmitWithSandPack(false);
    showPopUp();
  };

  const handleEditSubmission = () => {
    setIsSubmitted(false);
    setIsAddSubmission(true);
    showPopUp();

    if (
      assignmentTestData.hasOwnProperty("template") &&
      !submitWithSandPack &&
      status === constants.PROGRESS_STATUS.TO_BE_EVALUATED
    ) {
      setIsEditSubmission(true);
    }

    if (
      !assignmentTestData.hasOwnProperty("template") &&
      status === constants.PROGRESS_STATUS.TO_BE_EVALUATED
    ) {
      setIsEditSubmission(true);
    }

    if (!isAdmin) {
      setSubmitWithSandPack(false);
    }
  };

  const handleDownloadReferenceFileForLearner = async (link) => {
    let getCurrentLink = await getPreSignedUrl(
      link.path,
      undefined,
      link.path?.split(".")?.pop(),
      "GET",
    );
    const response = await fetch(getCurrentLink.url);
    if (!response.ok) throw new Error("Download failed");

    const blob = await response.blob();
    const url = window.URL.createObjectURL(blob);
    let anchorElement = document.createElement("a");

    anchorElement.download = link.name;
    anchorElement.href = url;
    // anchorElement.setAttribute("target", "_blank");
    anchorElement.click();
    document.body.appendChild(anchorElement);

    anchorElement.remove();
    window.URL.revokeObjectURL(url);
  };

  const handleDownloadLearnerSubmissionFiles = async (filePath) => {
    let URL = "",
      link = {},
      fileName = filePath.substring(filePath.lastIndexOf("/") + 1);

    if (process.env.REACT_APP_DEPLOYMENT === "LOCAL")
      URL = process.env.REACT_APP_NODE_API + filePath;
    else {
      let response = await getPreSignedUrl(
        filePath,
        undefined,
        filePath?.split(".")?.pop(),
        "GET",
      );

      URL = response.url;
    }

    link = {
      link: URL,
      name: fileName,
    };

    handleDownloadReferenceFileForLearner(link);
  };

  const handleNavContentOrAssignment = (
    data,
    lpId,
    type,
    lpConfigId,
    libId,
    status,
    learnerlist,
    fromreport,
    lid,
    cellobj,
  ) => {
    setFromReport(fromreport);
    setLearnerId(lid);

    if (data.name === null) {
      setShowNotify({
        show: true,
        title: "Info",
        msg: "There is no data to see. Contact your trainer.",
      });
    } else {
      setLibId(libId);
      setLibType(type);
      setStatus(status);
      setContentData({ ...data, switchedcount: data.switchedcount ?? 0 });
      setLpConfigId(lpConfigId);
      setScore(
        ((isAdmin && !isFromProfile.current) || isFromProfile.current) &&
          data.actualscore !== null
          ? data.actualscore
          : 0,
      );

      setApproveData({
        marks: data.marks,
        actualscore: data.actualscore,
      });

      if (
        (!isAdmin &&
          getDataFromStorage("role") !== "customer" &&
          Alert.showBreadCrumbsData.from !== "learner") ||
        isPreview
      ) {
        setShowMain(true);
      } else {
        setAssignmentTestData(data);
        setTestData({
          testtype: cellobj.type,
          testmode: cellobj.testMode,
          testname: cellobj.testName,
        });

        navigate("/assignment",{...location.state});
      }
    }
  };

  const setLinkForIndividual = (links, res) => {
    for (let i = 0; i < links.length; i++) {
      links[i].link = res.url[i];
    }
  };

  const handleGetLinks = useCallback(async () => {
    let linksArray = [];
    let linkTypeArray = [];
    try {
      let contentData1 = JSON.parse(JSON.stringify(assignmentTestData));
      let links =
        contentData1 !== "" &&
        contentData1?.hasOwnProperty("qnlinks") &&
        contentData1?.qnlinks !== null &&
        contentData1?.qnlinks !== undefined &&
        contentData1?.qnlinks.length > 0
          ? JSON.parse(contentData1.qnlinks)
          : contentData1 !== "" &&
            contentData1?.hasOwnProperty("links") &&
            contentData1?.links !== null &&
            contentData1?.links !== undefined &&
            contentData1?.links.length > 0
          ? JSON.parse(contentData1.links)
          : [];
      if (links.length === 0) {
        return;
      }
      let getLinkCount = 0;
      setLearnerVideoLink(contentData1.uploadedlink);

      setLearnerNotes(
        status === constants.PROGRESS_STATUS.UNLOCKED
          ? ""
          : contentData1?.answer !== null
          ? contentData1.answer
          : "",
      );

      /* get reference links */

      if (
        isAdmin &&
        (status === constants.PROGRESS_STATUS.EVALUATED ||
          status === constants.PROGRESS_STATUS.TO_BE_EVALUATED)
      ) {
        setLearnerNotes(
          contentData1?.answer !== null ? contentData1.answer : "",
        );
      }

      for (let link = 0; link < links.length; link++) {
        if (link.link !== null) {
          let fileName = links[link].link.substring(
            links[link].link.lastIndexOf("/") + 1,
          );

          links[link].id = nanoid();
          links[link].name = fileName;
          links[link].path = links[link].link;
          links[link].extension = fileName.replace(/^.*\./, "").toLowerCase();

          if (links[link].type !== constants.LINK_TYPE.EMBEDED_LINK) {
            if (process.env.REACT_APP_DEPLOYMENT === "LOCAL")
              links[link].link =
                process.env.REACT_APP_NODE_API + links[link].link;
            else {
              // let getPreSignedUrlRes = await getPreSignedUrl(
              //   links[link].link, undefined, links[link].link?.split(".").pop(), "GET"
              // );
              linksArray.push(links[link].link);
              linkTypeArray.push(links[link].link?.split(".").pop());
              // links[link].link = getPreSignedUrlRes.url;
            }
          } else links[link].name = links[link].link;

          getLinkCount++;
        } else links.splice(link, 0);
      }
      let getPreSignedUrlRes = await getPreSignedUrl(
        linksArray,
        undefined,
        linkTypeArray,
        "GET",
      );

      setLinkForIndividual(links, getPreSignedUrlRes);

      if (getLinkCount === links.length) setReferenceLinks(links);
    } catch (err) {
      setReferenceLinks([]);
    }
  }, [assignmentTestData]);

  const handleAssignment = (type, lpConfigId, libId, status, date) => {
    setIsLoaded(true);
    axios
      .post(
        `node/learner/course/assignment/${
          status === constants.PROGRESS_STATUS.EVALUATED ||
          status === constants.PROGRESS_STATUS.TO_BE_EVALUATED
            ? "report"
            : "get"
        }`,
        status === constants.PROGRESS_STATUS.EVALUATED ||
          status === constants.PROGRESS_STATUS.TO_BE_EVALUATED
          ? JSON.stringify({
              libid: libId,
              lpid: sessionStorage.getItem("lpId"),
              learnerid: getDataFromStorage("learnerid"),
            })
          : JSON.stringify({
              type: type,
              libid: libId,
              lpid: sessionStorage.getItem("lpId"),
              learnerid: getDataFromStorage("learnerid"),
            }),
        getHeaderDetailsForAxios(),
      )
      .then((res) => {
        if (res.data.resultCode !== constants.RESULT_STATUS.SUCCESS) {
          setShowNotify({
            show: true,
            title: "Info",
            msg: res.data.message,
          });
        } else {
          let data = res.data.data;

          data.dueDate = date;
          data.serverDate = res.headers.date;

          if (
            status === constants.PROGRESS_STATUS.UNLOCKED ||
            status === constants.PROGRESS_STATUS.REATTEMPT
          ) {
            setIsSubmitted(false);
          } else {
            setIsSubmitted(true);
          }

          setAssignmentTestData(data);
          handleNavContentOrAssignment(
            data,
            lpId,
            type,
            lpConfigId,
            libId,
            status,
          );
          setIsLoaded(false);
        }
      })
      .catch((error) => {
        getCatchBlockDetails(error);
      })
      .finally(() => setIsLoaded(false));
  };

  return {
    diff,
    showPopUp,
    referenceLinks,
    handleGetLinks,
    handleAssignment,
    setReferenceLinks,
    openSandPackEditor,
    submitWithSandPack,
    handleAddAssignment,
    handleEditSubmission,
    handleExitFullScreen,
    setSubmitWithSandPack,
    assignmentReferenceLinkRef,
    handleRequestFullScreenMode,
    handleNavContentOrAssignment,
    handleDownloadLearnerSubmissionFiles,
    handleDownloadReferenceFileForLearner,
  };
}
